import React, {
  useContext, useState,
} from 'react';
import _ from 'lodash';

import './styles.scss';
import Checkbox from '@common/components/checkbox';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { SetTerminalUsageConfirmed } from '@app/dev/actions/terminal';
import { useDispatch } from 'react-redux';

export const TerminalUsageConfirmationPopup = () => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ closePopup }] = useContext(PopupContext);
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="popup-content popup-small terminal-usage-confirmation-popup">
      <h3 className="popup-title">{t('Access Betting Interface')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('Your acceptance of the rules is required.')}</p>
        <div className="icon-block">
          <i className="global-icon icon-warning-transparent" />
        </div>
        <div className={`confirmation-checkbox ${isChecked && 'active'}`}>
          <Checkbox onChange={() => setIsChecked(!isChecked)} checked={isChecked} />
          <span>Je déclare avoir pris connaissance et accepté le règlement des sports et paris. Celui-ci est disponible à l'accueil de l'établissement. Ik verklaar dat ik het sport- en gokreglement heb gelezen en accepteer. Deze zijn verkrijgbaar bij de receptie van het etablissement. </span>
        </div>
      </div>
      <div className="popup-actions">
        <button
          onClick={() => {
            dispatch(SetTerminalUsageConfirmed(true));
            closePopup();
          }}
          type="button"
          className="popup-confirm-button"
          disabled={!isChecked}
        >
          {t('Continue')}
        </button>
      </div>
    </div>
  );
};
